import type { ReactNode } from 'react'
import { useLocation } from 'react-router-dom'
import { ErrorBoundary } from '../../features/shared/components/ErrorBoundary'

/**
 * A page's error stays with that page, inside its card: the header, rail and
 * side panels (an open chat, a half-written support request) stay as they
 * were, and moving to another page shows it instead of the error. Reads the
 * location here so only the boundary, not the whole layout, re-renders on
 * navigation.
 */
export default function PageErrorBoundary({ children }: { children: ReactNode }) {
  const { pathname } = useLocation()
  return (
    <ErrorBoundary resetKey={pathname} fallbackLayout="page">
      {children}
    </ErrorBoundary>
  )
}
